/**
 * @author wuTao
 * @description 个人路径完成率部分
 * @Date 2021/12/14
 */
import React from "react";
import {connect} from "dva";
import {component_tool, framework_tool} from "@/tool";
import {reduxTemplateCofig, templateConfig} from "./config";
import column from './column';
import {handleExport, mapStateToProps} from '../../utils';

const {WizContainer, WizReduxTemplate} = framework_tool;
const {WizModal} = component_tool

class PersonalPathCompletionRate extends WizContainer {
  componentName = "PersonalPathCompletionRate";

  constructor(props) {
    super(props)
  }

  handleAccomplishTypeClick = text => {
    WizModal.info({
      icon: null,
      title: '评语',
      content: (
        <div>{text}</div>
      ),
      okText: '关闭',
    });
  }

  _render() {
    let columnsType = true;
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: handleExport.bind(this, {title: '个人路径完成率', column, columnsType})
      },
    });

    return <React.Fragment>
      <WizReduxTemplate {..._reduxTemplateCofig} />
    </React.Fragment>
  }
}

export default connect(mapStateToProps.bind(this, {
  nameSpace: 'pathReport',
  method: 'getPageListStudentComplete'
}))(PersonalPathCompletionRate);
